import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import Footer from './Footer';
import { PostCard } from './PostCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/blog/posts`);
        if (mounted) setPosts(res.data || []);
      } catch (e) {
        if (mounted) setError('Could not load posts right now.');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
    // Runs once on mount only; `API` is a stable module-level constant.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Blog · Scatura Solutions';
  }, []);

  return (
    <div className="bg-white text-slate-900 antialiased overflow-x-hidden">
      <Navbar />
      <main className="pt-28 pb-24">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[12px] font-medium text-slate-700 uppercase tracking-[0.18em]">
              Blog
            </div>
            <h1 className="mt-4 font-display text-[40px] md:text-[56px] leading-[1.05] font-semibold tracking-tight text-slate-900">
              Field notes on resilience,{' '}
              <span className="bg-gradient-to-r from-violet-500 to-indigo-500 bg-clip-text text-transparent">
                automation and modern platforms.
              </span>
            </h1>
            <p className="mt-5 text-[16.5px] leading-relaxed text-slate-600 max-w-2xl">
              Hands-on write-ups from our engagements: chaos engineering game-days, self-healing patterns, Azure landing zones and the LLM automation stack we ship in production.
            </p>
          </div>

          <div className="mt-14" data-testid="blog-list">
            {loading && (
              <div className="text-slate-500 text-[14.5px]">Loading posts…</div>
            )}
            {!loading && error && (
              <div className="text-red-600 text-[14.5px]">{error}</div>
            )}
            {!loading && !error && posts.length === 0 && (
              <div className="rounded-3xl border border-dashed border-slate-300 bg-slate-50/50 p-10 text-center text-slate-500 text-[14.5px]">
                First post coming soon.
              </div>
            )}
            {!loading && posts.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {posts.map((p) => (
                  <PostCard key={p.id} post={p} />
                ))}
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
